module.exports = __webpack_public_path__ + "img/South Korea.2f80d5ec.svg";